import React from "react";
import {Field} from "react-final-form";
import {required} from "src/core/common/validations";
import CardListField from "src/core/payments/CardComponents/CardListField";
import Error from "src/core/common/components/elements/Error";
import MonerisPaymentSourcesDataSource from "src/core/payments/moneris/monerisPaymentSourcesDataSource";

function UserProfileMonerisCardSelectionField({paymentOption, form, readOnly, disabled}) {
  return (
    <Field
      validate={required}
      initialValue={undefined}
      name="payment.source"
      render={({input, meta}) => (
        <>
          <CardListField
            input={input}
            loading={false}
            disabled={disabled}
            order={undefined}
            form={form}
            readOnly={readOnly}
            paymentOption={paymentOption}
            profile={true}
            dataSource={paymentSourcesDataSource}
            showForm={undefined}
            hideAddButton={true}
          />
          {meta.touched && <Error>{meta.error}</Error>}
        </>
      )}
    />
  );
}

const paymentSourcesDataSource = new MonerisPaymentSourcesDataSource();

export default UserProfileMonerisCardSelectionField;
